import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { DashboardLayout } from "../components/DashboardLayout";
import { API } from "../lib/constants";

export default function HistoryPage() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadHistory = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/content/history`);
      setHistory(data);
    } catch {
      // Failed to load
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadHistory();
  }, [loadHistory]);

  return (
    <DashboardLayout>
      <div className="p-6 md:p-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Content History</h1>
          <p className="text-gray-600">View your previously generated content</p>
        </div>

        {loading ? (
          <div className="text-center py-12 text-gray-500">Loading...</div>
        ) : history.length === 0 ? (
          <div className="bg-white border border-black p-12 text-center" data-testid="empty-history">
            <p className="text-gray-500 mb-4">No content generated yet</p>
            <Link to="/dashboard/text" className="text-[#0066FF] font-bold hover:underline">Start creating</Link>
          </div>
        ) : (
          <div className="space-y-4">
            {history.map((item) => (
              <div key={`${item.created_at}-${item.prompt}`} className="bg-white border border-black p-6" data-testid="history-item">
                <div className="flex items-center justify-between mb-3">
                  <span className={`px-3 py-1 text-xs font-bold ${item.type === 'text' ? 'bg-[#0066FF] text-white' : 'bg-[#FF2A00] text-white'}`}>
                    {item.type === 'text' ? item.content_type?.toUpperCase() : 'IMAGE'}
                  </span>
                  <span className="text-sm text-gray-500">{new Date(item.created_at).toLocaleDateString()}</span>
                </div>
                <p className="font-medium mb-2">{item.prompt}</p>
                {item.type === 'text' && item.result && (
                  <p className="text-sm text-gray-600 line-clamp-3">{item.result}</p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
